import { Env } from 'modules/common';

interface IConfig {
  stake: {
    target: `0x${string}::native_pool::stake`;
    nativePoolId: `0x${string}`;
    certMetadata: `0x${string}`;
    iotaSystemState: '0x5';
    token: string;
  };
  unstake: {
    target: `0x${string}::native_pool::unstake`;
    token: `0x${string}::cert::CERT`;
  };
  network: string;
  api: string;
}

const stageConfig: IConfig = {
  stake: {
    target:
      '0xb4f5bdb10ca2acf34d28ac291455e54843b6e2c843b9f279b47890e74a957a0a::native_pool::stake',
    nativePoolId:
      '0xe9d03191a150269de0740c9194f0de45a560432dbc972bcb2460813ce843dcaa',
    certMetadata:
      '0xf77ffe15ad2dfd2f24553f8e94b0e7dc85450326e60e62546adb80998f56de46',
    iotaSystemState: '0x5',
    token: '0x2::iota::IOTA',
  },
  unstake: {
    target:
      '0xb4f5bdb10ca2acf34d28ac291455e54843b6e2c843b9f279b47890e74a957a0a::native_pool::unstake',
    token:
      '0x1461ef74f97e83eb024a448ab851f980f4e577a97877069c72b44b5fe9929ee3::cert::CERT',
  },
  network: 'testnet',
  api: 'https://api.testnet.swirlstake.com',
} as const;

const prodConfig: IConfig = {
  stake: {
    target:
      '0xa38a034356187b52c603282198fc831f0f710e16a61b141986697372ef16b292::native_pool::stake',
    nativePoolId:
      '0x02d641d7b021b1cd7a2c361ac35b415ae8263be0641f9475ec32af4b9d8a8056',
    certMetadata:
      '0x8c25ec843c12fbfddc7e25d66869f8639e20021758cac1a3db0f6de3c9fda2ed',
    iotaSystemState: '0x5',
    token: '0x2::iota::IOTA',
  },
  unstake: {
    target:
      '0xa38a034356187b52c603282198fc831f0f710e16a61b141986697372ef16b292::native_pool::unstake',
    token:
      '0x346778989a9f57480ec3fee15f2cd68409c73a62112d40a3efd13987997be68c::cert::CERT',
  },
  network: 'mainnet',
  api: 'https://api.swirlstake.com',
} as const;

export function getConfig(env: Env): typeof prodConfig {
  switch (env) {
    case Env.dev:
      return stageConfig;
    case Env.stage:
      return stageConfig;
    case Env.prod:
      return prodConfig;
    default:
      throw new Error('Configuration not found');
  }
}
